enum AlertsTypes {
  AddAlertRequest = 'Alerts.AddAlert.Request',
  AddAlertSuccess = 'Alerts.AddAlert.Request',
  AddAlertFailure = 'Alerts.AddAlerts.Failure',
  UpdateAlertRequest = 'Alerts.UpdateAlert.Request',
  UpdateAlertSuccess = 'Alerts.UpdateAlert.Request',
  UpdateAlertFailure = 'Alerts.UpdateAlert.Failure',
  DeleteAlertRequest = 'Alerts.DeleteAlert.Request',
  DeleteAlertSuccess = 'Alerts.DeleteAlert.Request',
  DeleteAlertFailure = 'Alerts.DeleteAlert.Failure',
  FetchAlertsRequest = 'alerts.Request',
  FetchAlertsSuccess = 'alerts.Success',
  FetchAlertsFailure = 'alerts.Failure',
  FetchAlertDataRequest = 'alertData.Request',
  FetchAlertDataSuccess = 'alertData.Success',
  FetchAlertDataFailure = 'alertData.Failure',
  OverlayFetchAlertsRequest = 'alerts.overlay.Request',
  OverlayFetchAlertsSuccess = 'alerts.overlay.Success',
  OverlayFetchAlertsFailure = 'alerts.overlay.Failure',
}

enum NotificationsTypes {
  FetchAlertNotificationsRequest = 'notifications.Request',
  FetchAlertNotificationsSuccess = 'notifications.Success',
  FetchAlertNotificationsFailure = 'notifications.Failure',
  OverlayFetchAlertNotificationsRequest = 'notifications.overlay.Request',
  OverlayFetchAlertNotificationsSuccess = 'notifications.overlay.Success',
  OverlayFetchAlertNotificationsFailure = 'notifications.overlay.Failure',
  FetchServerNotificationsRequest = 'notifications.server.Request',
  FetchServerNotificationsSuccess = 'notifications.server.Success',
  FetchServerNotificationsFailure = 'notifications.server.Failure',
  NotificationsSeenRequest = 'notifications.seen.Request',
  NotificationsSeenSuccess = 'notifications.seen.Success',
  NotificationsSeenFailure = 'notifications.seen.Failure',
}

export { AlertsTypes, NotificationsTypes };
